import { useState, useCallback, useEffect } from 'react';

export type SignatureOption = { label: string; value: string };

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.getItem('igtoken') || ''}`,
    'Content-Type': 'application/json',
    NCToken: localStorage.getItem('NCToken') || '',
  };
}

export function useSignatures() {
  const [signatureOptions, setSignatureOptions] = useState<SignatureOption[]>([]);

  const refetchSignatures = useCallback(async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_COIPortal_Url}/api/igigcoi/signatures`,
        { headers: authHeaders() },
      );
      if (!res.ok) return;
      const data: { id: string; name: string }[] = await res.json();
      setSignatureOptions(
        Array.isArray(data) ? data.map(s => ({ label: s.name, value: s.id })) : [],
      );
    } catch {
      // non-critical
    }
  }, []);

  useEffect(() => { refetchSignatures(); }, [refetchSignatures]);

  return { signatureOptions, refetchSignatures };
}
